import service from '@/api/request';

//获取验证码
export type AuthCodeResponse = { pictureCheckCode: string };
export const getAuthCode = () => service.post<null, AuthCodeResponse>('/security/getAuthCode');
export const login = data => service.post<null, { token: string }>('/api/cas/login/smsLogin', data);
export const loginOut = () => service.post('/api/cas/login/logout');
export type DongdongLinkResponse = { dongdongUri: string };
/** 获取咚咚接入地址 */
export const getDongdongLink = () => service.post<null, DongdongLinkResponse>('/api/cas/login/getDongdongAuthInfo');
export type DongdongLoginResponse = {
  authority: string; // 权限类型 1-超级管理员; 2-学校领队; 3-管理员(仅查询) ,
  extendedPermission: string; //集成权限类型 1金融挑战赛；2投资分析研究；3金融知识竞赛；4自建比赛；5基金模拟投资 ,
  orgId: string;
  orgmenuName: string;
  userId: string; //用户ID，取mid ,
  userName: string;
  usermenuName: string;
  tokenmenuName: string;
  token: string;
};
/** 咚咚登录认证 */
export const dongdongLogin = data =>
  service.post<null, DongdongLoginResponse>('/api/cas/login/dongdongAuthLogin', data);
export const getSidebars = data => service.post('/api/cas/common/getUserMenuList', data);
// export const getSidebars = () =>
//   Promise.resolve([
//     {
//       menuName: '系统管理',
//       path: '/system',
//       children: [
//         {
//           menuName: '权限管理',
//           path: '/system/auth',
//           children: [
//             {
//               menuName: '角色管理',
//               path: '/system/auth/role',
//             },
//             {
//               menuName: '用户管理',
//               path: '/system/auth/user',
//             },
//             {
//               menuName: '菜单管理',
//               path: '/system/auth/menu',
//             },
//           ],
//         },
//       ],
//     },
//     {
//       menuName: '证书中心配置',
//       path: '/cert',
//       children: [
//         {
//           menuName: '证书配置',
//           path: '/cert/cert-manage',
//         },
//         {
//           menuName: '证书字段配置',
//           path: '/cert/params-manage',
//         },
//         {
//           menuName: '发布配置',
//           path: '/cert/publish-manage',
//         },
//       ],
//     },
//     {
//       menuName: '赛事管理',
//       path: '/comp',
//       children: [
//         {
//           menuName: '赛事配置',
//           path: '/comp/compConfig',
//         },
//         {
//           menuName: '赛项配置',
//           path: '/comp/raceConfig',
//         },
//         {
//           menuName: '赛事权限管理',
//           path: '/comp/compAuth',
//         },
//       ],
//     },
//   ]);
export interface CompList {
  compId: string;
  compName: string;
  compType: number;
}
export const getUserCompList = () => service.post<null, CompList[]>('/api/cas/common/getUserCompList');
export const getMsgCode = data => service.post('/api/cas/login/sendMsgCode', data);
export const deleteUser = data => service.post('/api/cas/user/delete', data);
export const getUserList = data => service.post<null, Global.RecordResponse>('/api/cas/user/queryForPage', data);
export interface UserDetailResponse {
  menuName: string;
  phone: string;
  oaCode: string;
  [key: string]: any;
}
export const addUser = data => service.post('/api/cas/user/create', data);
export const updateUser = data => service.post('/api/cas/user/update', data);
export const updateUserRole = data => service.post('/api/cas/role/updateUserRole', data);
export const getUserInfo = data => service.post<null, UserDetailResponse>('/api/cas/user/queryById', data);
export const getUserRoleList = data => service.post<null, Array<any>>('/api/cas/role/getUserRoleList', data);
export const changPassword = data => {
  return service({
    url: '/security/user/changePassword',
    method: 'post',
    data,
  });
};
